import React from "react";

function SideMenu() {
  return (
    <nav className="p-6 text-lg font-medium leading-loose text-gray-400 bg-gray-100 rounded-2xl min-w-60 w-[297px] max-md:px-5">
      <button className="flex gap-2 items-start px-4 py-2 max-w-full text-white bg-rose-700 rounded-[400px] w-[249px]">
        <span className="flex shrink-0 w-6 h-6" />
        <span className="flex-1 shrink basis-0">Personal Data</span>
      </button>
      <button className="flex gap-2 items-start px-4 py-2 mt-3 max-w-full rounded-[400px] w-[249px]">
        <span className="flex shrink-0 w-6 h-6" />
        <span className="flex-1 shrink basis-0">Log out</span>
      </button>
      <button className="flex gap-2 items-start px-4 py-2 mt-3 max-w-full rounded-[400px] w-[249px]">
        <span className="flex shrink-0 w-6 h-6" />
        <span className="flex-1 shrink basis-0">delete account</span>
      </button>
    </nav>
  );
}

export default SideMenu;
